'use strict';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {getUserId} from '../../auth/reducers';
import {USER_PRIORITY} from '../enums/USER_PRIORITIES';
import {USER_PRIORITIES_COLLECTION} from './config';


export function UserPinDomainProvider() {
  return {
    $get: [
      '$log',
      'AbstractDomainClass',
      '$injector',
      '$ngRedux',
      'DomainUtils',
      'restUtils',
      function (
        $log,
        AbstractDomainClass,
        $injector,
        $ngRedux,
        DomainUtils,
        restUtils,
      ) {
        function UserPinDomain(data) {
          AbstractDomainClass.call(this, UserPinDomain, data);
        }

        AbstractDomainClass.__inheritFrom(UserPinDomain, 'UserPinDomain', USER_PRIORITIES_COLLECTION);

        UserPinDomain.$constraints.addConstraints({
          user: {type: 'DomainLink', domainClass: 'UserDomain'/*, simpleLink: true*/},
          priority: {type: 'number', defaultValue: USER_PRIORITY.PINNED},
          serverPriority: {type: 'number', defaultValue: USER_PRIORITY.NONE, nullable: true},
          target: {type: 'Domain', belongsTo: true},
          /* @Deprecated */
          metadata: {type: 'JSON', nullable: true},
          uid: {type: 'string', nullable: true},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        UserPinDomain.create = restUtils.create(UserPinDomain, {
          getBody: data => data,
          canUseFallback: false,
        });

        UserPinDomain.prototype.update = restUtils.updateProto(UserPinDomain);

        UserPinDomain.prototype.delete = restUtils.deleteProto(UserPinDomain);

        UserPinDomain.getPin = function getPin(targetId) {
          const userId = getUserId($ngRedux.getState());
          return UserPinDomain.$get(UserPinDomain.constructId(userId, targetId));
        };

        UserPinDomain.pin = function pin(target) {
          const targetLink = DomainUtils.getAsLink(target);
          if (!targetLink) return Promise.resolve(null);

          /* This is cheating, using implementation details of restUtils.create. Strictly, its contract requires a valid domain instance */
          return UserPinDomain.create({
            targetId: targetLink.id,
            targetCollection: targetLink.collection,
            priority: USER_PRIORITY.PINNED,
          });
        };

        UserPinDomain.togglePin = function togglePin(target) {
          return UserPinDomain.getPin(getId(target)).then(function (pin) {
            // Unpin this target
            if (pin) {
              return pin.togglePin();
            } else {
              return UserPinDomain.pin(target).then(() => true);
            }
          });
        };

        UserPinDomain.constructId = function constructId(user, target) {
          return _getId(user) + _getId(target);
        };

        UserPinDomain.prototype.isPinned = function isPinned() {
          return this.priority > USER_PRIORITY.NONE;
        };

        UserPinDomain.prototype.togglePin = function togglePin() {
          if (this.priority === USER_PRIORITY.PINNED) {
            return this.unpin().then(function () {
              return false;
            });

          } else {
            return this.pin().then(function () {
              return true;
            });
          }
        };

        UserPinDomain.prototype.pin = function pin() {
          this.priority = USER_PRIORITY.PINNED;
          return this.update();
        };

        UserPinDomain.prototype.unpin = function unpin() {
          if (!this.serverPriority || this.serverPriority === USER_PRIORITY.NONE) {
            return this.delete();
          } else {
            this.priority = this.serverPriority;
            return this.update();
          }
        };

        function _getId(entity) {
          if (isString(entity)) {
            return entity;
          } else if (isObject(entity)) {
            return getId(entity);
          } else {
            $log.warn('UserPinDomain._getId: passed invalid entity', entity);
          }
        }

        return UserPinDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/priorities/domain/UserPinDomain.js